import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { useFlow } from '@router/stackflow';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import useNearShop from './hooks/useNearShop';

function NearBy() {
    const shop = useNearShop();
    const { push } = useFlow();
    const { t } = useTranslation('main');
    if (shop) {
        const {
            thumbnailImageUrl, name, address, id,
        } = shop;
        return (
            <Container>
                <Text size='lg' fontWeight='bold'>
                    {t('nearBy.title')}
                </Text>
                <Content onClick={() => push('ItemsActivity', { shopId: id, type: 'ALL' })}>
                    <Image src={thumbnailImageUrl}
                        width={48}
                        height={48} />
                    <TextContainer spacing={4}>
                        <Text size='lg' fontWeight='medium' ellipsis>
                            {name}
                        </Text>
                        <Text color={colors.gray6} size='s' ellipsis>{address}</Text>
                    </TextContainer>
                    <ArrowLineRight size={18}/>
                </Content>
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled.div`
    padding: 0 20px;
    margin-bottom: 48px;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    width: 100%;
`;

const Content = styled.div`
    padding: 16px;
    background-color: ${colors.gray1};
    border-radius: 8px;
    display: flex;
    align-items: center;
    column-gap: 12px;
`;

const TextContainer = styled(Column)`
    flex: 1;
    overflow: hidden;
`;

export default NearBy;
